import { useMemo } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { checkEmptyObj, checkIf, getUserRole, UserRoles } from "../../utils";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import Index from "../../pages/Index";

export default function NavigationPlan() {
  const user = useSelector((state: RootState) => state.user);
  const [searchParams] = useSearchParams();
  const invitationCode = searchParams.get("code");

  if (!checkEmptyObj(user)) {
    return <Navigate to="/users" />;
  } else {
    return <Index />;
  }
}
